import { useEffect, useState } from "react";
import { Download, Printer, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { renderGiftCard } from "@/lib/giftCard";

export default function GiftCard({ gift, preview = false }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    renderGiftCard(gift).then(setUrl).catch(() => toast.error("Could not create the gift card image."));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gift.code, gift.message, gift.from_name]);

  const print = () => {
    const win = window.open("", "_blank");
    if (!win) return toast.error("Please allow pop-ups to print the card.");
    win.document.write(
      `<html><head><title>Gift card ${gift.code}</title><style>@page{size:landscape;margin:10mm}body{margin:0;display:flex;align-items:center;justify-content:center}img{width:100%;-webkit-print-color-adjust:exact;print-color-adjust:exact}</style></head><body><img src="${url}" onload="setTimeout(()=>{window.print()},200)"/></body></html>`
    );
    win.document.close();
  };

  return (
    <div className="mt-8" data-testid={preview ? "gift-card-preview" : "gift-card"}>
      <p className="font-mono-ui text-[10px] uppercase tracking-[0.25em] text-primary-gold mb-3">{preview ? "Card preview — your real code appears after payment" : "Your gift card"}</p>
      {url ? (
        <img src={url} alt={`Gift card with code ${gift.code}`} className="w-full border border-white/10" data-testid="gift-card-image" />
      ) : (
        <div className="aspect-[16/10] flex items-center justify-center border border-white/10"><Loader2 className="w-5 h-5 text-primary-gold animate-spin" /></div>
      )}
      {!preview && <div className="flex flex-wrap gap-3 mt-4">
        <a
          href={url || undefined}
          download={`leckie-gift-card-${gift.code}.png`}
          data-testid="gift-card-download"
          className={`btn-gold px-5 py-3 font-mono-ui text-xs uppercase tracking-[0.18em] flex items-center gap-2 ${url ? "" : "pointer-events-none opacity-50"}`}
        >
          <Download className="w-4 h-4" /> Download image
        </a>
        <button onClick={print} disabled={!url} data-testid="gift-card-print" className="btn-ghost px-5 py-3 font-mono-ui text-xs uppercase tracking-[0.18em] flex items-center gap-2 disabled:opacity-50">
          <Printer className="w-4 h-4" /> Print card
        </button>
      </div>}
    </div>
  );
}
